import React from "react";
import { InputError } from "./inputError";

interface ICheckBoxNullableProps {
    label: React.ReactNode;
    name?: string;
    checked: boolean | null;
    onChange: (checked: boolean | null) => void;
    disabled?: boolean;
    descriptions?: { checked: string, unchecked: string, half: string };
    error?: string;
    className?: string;
    title?: string;
}

export interface ICheckBoxProps {
    checked: boolean;
    label?: React.ReactNode;
    onChange: (checked: boolean) => void;
    name?: string;
    disabled?: boolean;
    error?: string;
    className?: string;
    title?: string;
}

export class CheckBox extends React.PureComponent<ICheckBoxProps>{
    render() {
        const { label, checked, onChange, disabled, name, error, className, title } = this.props;
        return <CheckBoxBase
            checked={checked}
            label={label}
            onChange={onChange}
            disabled={disabled}
            name={name}
            error={error}
            className={className}
            title={title}
        />
    }
}

export class CheckBoxNullable extends React.PureComponent<ICheckBoxNullableProps>{
    private static DefaultDescriptions = {
        checked: "(Solo con)",
        unchecked: "(Solo senza)",
        half: "(Tutto)",
    }
    render() {
        const { label, checked, onChange, disabled, name, descriptions, error } = this.props;
        return <CheckBoxBase
            checked={checked}
            label={label}
            onChange={onChange}
            disabled={disabled}
            name={name}
            descriptions={descriptions ?? CheckBoxNullable.DefaultDescriptions}
            isNullable
            error={error}
        />
    }
}

interface ICheckBoxPureProps extends ICheckBoxNullableProps {
    isNullable?: boolean;
}

class CheckBoxBase extends React.PureComponent<ICheckBoxPureProps>{

    private getNextStatus(currentStatus: boolean | null) {
        if (currentStatus == null)
            return true
        else if (currentStatus == true)
            return false
        else
            return null
    }

    private getComponent = (checked: boolean | null, disabled: boolean, isNullable: boolean) => {
        const nextTransition = isNullable ? this.getNextStatus(checked) : !checked;
        const baseClass = `bntech-checkbox ${disabled ? "disabled" : ""}`
        const descriptions = this.props.descriptions;
        const className = "checkbox-detail" + (this.props.className ? ` ${this.props.className}` : "")
        if ((isNullable && checked == null) || (!isNullable && !checked))
            return (<>
                <span
                    className={baseClass}
                    onClick={this.onChange.bind(this, nextTransition)}
                />
                <strong
                    style={{ color: disabled ? "#888" : undefined }}
                    onClick={this.onChange.bind(this, nextTransition)}
                >
                    {this.props.label}
                </strong>
                {descriptions && <div className={className} title={this.props.title}>{descriptions.half}</div>}
            </>)
        else if (checked == true)
            return (<>
                <span className={`${baseClass} positive`}
                    onClick={this.onChange.bind(this, nextTransition)}
                >
                    <svg
                        viewBox="0 0 18 18"
                        fill="none"
                        stroke="currentcolor"
                        strokeLinecap="round"
                        strokeWidth="10%">
                        <path d="M4,10 L8,14 14,4" />
                    </svg>
                </span>
                <strong
                    style={{ color: disabled ? "#888" : undefined }}
                    onClick={this.onChange.bind(this, nextTransition)}
                >
                    {this.props.label}
                </strong>
                {descriptions && <div className={className} title={this.props.title}>{descriptions.checked}</div>}
            </>)
        else
            return (
                <>
                    <span
                        className={`${baseClass} negative`}
                        onClick={this.onChange.bind(this, nextTransition)}
                    >
                        <svg
                            viewBox="0 0 18 18"
                            fill="none"
                            stroke="currentcolor"
                            strokeLinecap="round"
                            strokeWidth="10%">
                            <path d="M4,14 L14,4 M14,14 L4,4" />
                        </svg>
                    </span>
                    <strong
                        style={{ color: disabled ? "#888" : undefined }}
                        onClick={this.onChange.bind(this, nextTransition)}
                    >
                        {this.props.label}
                    </strong>
                    {descriptions && <div className={className} title={this.props.title}>{descriptions.unchecked}</div>}
                </>)
    }

    private onChange = (value: boolean | null) => {
        if (!this.props.disabled)
            this.props.onChange(value);
    }

    render() {
        const { checked, disabled, isNullable, error } = this.props;
        return (
            <>
                <div style={{ display: "inline-block", verticalAlign: "top" }}>
                    {this.getComponent(checked, disabled || false, isNullable || false)}
                </div>
                {error && <div><InputError error={error} /></div>}
            </>
        );
    }
}
